import $ from 'jquery';
if (!window.$ && !window.jQuery) {
  window.jQuery = window.$ = $;
}
